import VideoLoop from './VideoLoop';

export default VideoLoop;
